import { parse } from 'mathjs/lib/esm/number';

export const isMathJsFormulaError = { isMathJsFormula: true };

export function isMathJsFormula(str: string) {
  try {
    parse(str);
    return true;
  } catch (err) {
    return false;
  }
}
